module.exports = __webpack_public_path__ + "static/media/RecomendaVitoria.82df48b4.jpg";